'use client'

import { trackAppRouter } from '@socialgouv/matomo-next'
import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

type GlobalAnalyticsProps = {
  siteId: string
}

function GlobalAnalytics({ siteId }: GlobalAnalyticsProps) {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    trackAppRouter({
      url: 'https://matomo.oreme.org',
      siteId: siteId,
      pathname,
      searchParams,
    })
  }, [siteId, pathname, searchParams])

  return null
}

export { GlobalAnalytics }
